import { PrimaryButton } from '@lib/common';
import { Modal } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "modal-guidelinecomponent__StyledModal",
  componentId: "sc-n1sgbu-0"
})(["width:auto !important;.ant-modal-content{height:100vh;width:1000px !important;}.ant-modal-body{height:calc(100vh - 54px - 54px);overflow:auto;}"]);
export var ModalGuideline = function ModalGuideline(_ref) {
  var isGuideVisible = _ref.isGuideVisible,
      onCancel = _ref.onCancel,
      children = _ref.children,
      label = _ref.label;
  return /*#__PURE__*/_jsx(StyledModal, {
    title: label.guidelineToCreatingQuestion,
    centered: true,
    closable: true,
    wrapClassName: "guide-modal",
    open: isGuideVisible,
    onOk: onCancel,
    onCancel: onCancel,
    footer: [/*#__PURE__*/_jsx(PrimaryButton, {
      onClick: onCancel,
      children: "OK"
    }, "guideOk")],
    children: children
  });
};